<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <label style="margin-right: 8px">单据编号</label>
      <span v-if="!!neiling.id">{{ neiling.code }}</span>
      <el-input v-else v-model="neiling.code" style="width: 150px"></el-input>
      <label style="margin-left: 12px; margin-right: 8px">内领仓库</label>
      <span v-if="readOnly">{{ neiling.warehouseId | valueName('Warehouse') }}
      - {{ neiling.warehousePosId | valueName('WarehousePos') }}</span>
      <warehouse-select v-else v-model="neiling.warehouse"></warehouse-select>
      <label style="margin-left: 12px; margin-right: 8px">内领日期</label>
      <span v-if="readOnly">{{ neiling.outDate }}</span>
      <el-date-picker v-else style="max-width: 130px;"
                      v-model="neiling.outDate"
                      type="date"
                      format="yyyy-MM-dd"
                      placeholder="选择日期">
      </el-date-picker>
      <label style="margin-left: 12px; margin-right: 8px">经办人</label>
      <span v-if="readOnly">{{ neiling.operatorUserName }}</span>
      <remote-select v-else class-name="NeilingUser" v-model="neiling.operatorUserAccount"
                     :options="neilingUserOptions" selectFirst>
      </remote-select>
    </div>
    <el-table :data="neiling.goodsList" class="table-border" header-cell-class-name="table-head"
              :max-height="tableHeight">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="商品名称" prop="name"></el-table-column>
      <el-table-column label="商品编号" prop="code"></el-table-column>
      <el-table-column label="商品类型">
        <template #default="{row}">
          {{ row.typeCode | valueName('GOODS_TYPE') }}{{ row.typeCode }}
        </template>
      </el-table-column>
      <el-table-column label="单位" prop="unit"></el-table-column>
      <el-table-column label="生产日期" prop="productionDate"></el-table-column>
      <el-table-column label="保质期天数" prop="expireDays"></el-table-column>
      <el-table-column label="单价（元）" prop="price"></el-table-column>
      <el-table-column label="数量" prop="num"></el-table-column>

      <el-table-column v-if="!readOnly" :width="120" align="center" fixed="right">
        <template #header>
          <el-button type="primary" @click="selectGoods">商品选择</el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" size="mini" @click="deleteGoods(row)" class="danger">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="display: flex; margin-top: 20px; justify-content: space-between">
      <div style="display: flex; align-items: center">
        <label style="width: 70px">物流公司</label>
        <el-input :disabled="readOnly" v-model="neiling.logisticsCompany"></el-input>
      </div>
      <div style="display: flex; align-items: center;">
        <label style="width: 70px">物流单号</label>
        <el-input :disabled="readOnly" v-model="neiling.logisticsCode" style="flex-shrink: 1"></el-input>
      </div>
      <div style="display: flex; align-items: center;">
        <label style="width: 70px">运费金额</label>
        <el-input :disabled="readOnly" v-model="neiling.freight"></el-input>
      </div>
      <div style="display: flex; align-items: center;">
        <label style="width: 70px">结算账户</label>
        <el-input :disabled="readOnly" v-model="neiling.settlementAccount"></el-input>
      </div>
    </div>
    <div style="margin-top: 20px; display: flex">
      <label style="width: 30px">备注</label>
      <el-input :disabled="readOnly" type="textarea" :rows="4" v-model="neiling.remarks" maxlength="200"
                resize="none"></el-input>
    </div>

    <div style="float: right; margin-top: 20px;">
      <template v-if="!readOnly">
        <el-button type="primary" @click="applyNeiling">申 请</el-button>
        <el-button @click="save">保 存</el-button>
        <el-button @click="cancel">取 消</el-button>
      </template>
      <el-button v-else @click="cancel">返 回</el-button>
    </div>

    <select-out-goods-dialog :visible.sync="dialog.show" :outbound="dialog.neilng"
                             :cand-goods-list="goodsList"
                             @update="updateGoodsList"></select-out-goods-dialog>
  </div>
</template>

<script>

import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'
import WarehouseSelect from '@/components/selector/WarehouseSelect'
import RemoteSelect from '@/components/selector/RemoteSelect'
import SelectOutGoodsDialog from '@/views/outbound/SelectOutGoodsDialog'
import { findGoods } from '@/utils/request'
import { Neiling } from '@/store/objdef/objectDef'
import authority from '@/utils/authority'

export default {
  name: 'NeilingGoods',
  mixins: [resizeCaptureMixin],
  components: { SelectOutGoodsDialog, RemoteSelect, WarehouseSelect },
  data () {
    return {
      neiling: new Neiling(),
      dialog: {
        show: false,
        neilng: new Neiling()
      },
      goodsList: null,
      oldNeiling: null
    }
  },
  created () {
    this.$store.dispatch('data/kvList', 'NeilingUser')
    this.$store.dispatch('neiling/all').then(list => {
      for (const neiling of list) {
        if (neiling.id.toString() === this.$route.query.neilingId) {
          this.neiling = neiling
          this.oldNeiling = this.$_.cloneDeep(this.neiling)
          break
        }
      }
    })
  },
  methods: {
    selectGoods () {
      if (!this.neiling.warehouse || !this.neiling.warehouse[1]) {
        this.$alert('请选择仓库！')
        return
      }
      this.dialog.neilng = this.$_.cloneDeep(this.neiling)
      this.dialog.show = true
    },
    deleteGoods (goods) {
      this.$confirm(`确认删除商品【${goods.name}】, 是否继续?`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (const index in this.neiling.goodsList) {
          const item = this.neiling.goodsList[index]
          if (item.id === goods.id) {
            this.neiling.goodsList.splice(index, 1)
          }
        }
      }).catch(() => {
      })
    },
    updateGoodsList (goodsList) {
      this.neiling.goodsList = goodsList
    },
    applyNeiling () {
      if (!this.check()) return
      if (this.neiling.goodsList.length === 0) {
        this.$alert('请选择商品！')
        return
      }
      this.neiling.status = 1
      this.save()
    },
    save () {
      if (!this.check()) return
      if (typeof this.neiling.outDate === 'object') {
        this.neiling.outDate = this.neiling.outDate.format('yyyy-MM-dd')
      }
      const isAdd = !this.neiling.id
      this.$store.dispatch('neiling/' + (isAdd ? 'add' : 'updateOne'), this.$_.cloneDeep(this.neiling)).then(() => {
        this.$router.go(-1)
        this.$message.success((this.neiling.status === 0 ? '保存' : '提交申请') + '成功!')
      })
    },
    cancel () {
      this.$router.go(-1)
    },
    check () {
      if (!this.neiling.warehouse || !this.neiling.warehouse[1]) {
        this.$alert('请选择仓库！')
        return false
      }
      if (!this.neiling.outDate) {
        this.$alert('请选择内领日期！')
        return false
      }
      return true
    }
  },
  computed: {
    tableHeight () {
      return this.clientHeight - 224 - 50
    },
    readOnly () {
      return this.neiling.status !== 0 || !this.$hasPermission(authority.NEILING)
    },
    neilingUserOptions () {
      const options = [{ id: this.$store.state.user.userAccount, name: this.$store.state.user.name }]
      for (const item of this.$store.state.data.NeilingUser || []) {
        options.push({ id: item.account, name: item.name })
      }
      return options
    }
  },
  watch: {
    'neiling.warehouse': {
      handler (warehouse) {
        if (warehouse && warehouse[1]) {
          this.neiling.goodsList = this.neiling.goodsList
            .filter(item => item.warehouseId === warehouse[0] && item.warehousePosId === warehouse[1])
          findGoods({ warehouseId: warehouse[0], warehousePosId: warehouse[1] }).then(resp => {
            this.goodsList = resp.data
            if (this.oldNeiling) {
              for (const goods of this.goodsList) {
                for (const oldGoods of this.oldNeiling.goodsList) {
                  if (goods.id === oldGoods.id && goods.inboundId === oldGoods.inboundId) {
                    goods.remain += oldGoods.num
                    break
                  }
                }
              }
            }
          })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ th {
  height: 50px;
}

label {
  margin-right: 10px;
  font-size: 13px;
  color: #646464;
}
</style>
